import { Container, Box, Button, Icon } from "@chakra-ui/react";
import React from "react";
import { Text } from "@chakra-ui/react";
import { QuestionIcon } from "@chakra-ui/icons";
import { Link, Navigate, NavLink } from "react-router-dom";
import Navbar from "./Navbar";
import Content from "./Content";

function Home() {
  return (
    <>
        <Navbar/>
      <Container maxW="full" paddingBottom="165px">
        <Box mt={200}>
          <Text
            style={{
              textShadow: "2px 2px 4px #000000",
              fontFamily: "sans-serif",
            }}
            color="white"
            as="b"
            fontSize="6xl"
          >
            A better way to track your workouts
          </Text>
        </Box>
        <Box mt={16}>
          <Button
            style={{
              padding: "30px 100px 30px 100px",
              fontSize: "20px",
              boxShadow: "1px 1px 4px rgb(0 0 0 / 50%)",
            }}
            colorScheme="blue"
            variant="solid"
          >
            Start Free
          </Button>
        </Box>
        <Box
          mt={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Link
            style={{
              fontSize: "18px",
              color: "white",
              textShadow: "2px 2px 4px #000000",
              fontFamily: "sans-serif",
            }}
          >
            See How it Works.
          </Link>
          <QuestionIcon color="white"></QuestionIcon>
        </Box>
      </Container>
      <Content/>
    </>
  );
}
export default Home;
